module.exports = __webpack_public_path__ + "static/yuraima-c2021fe506620147ea22604555de529d.jpg";